import * as React from "react";
import { cn } from "../../lib/utils";

export interface SwitchProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Switch = React.forwardRef<HTMLInputElement, SwitchProps>(
  ({ className, ...props }, ref) => {
    return (
      <label className={cn("relative inline-flex items-center cursor-pointer", className)}>
        <input
          type="checkbox"
          ref={ref}
          className="sr-only peer"
          {...props}
        />
        {/* Track */}
        <span className="w-11 h-6 rounded-full bg-input peer-checked:bg-primary transition-colors"></span>
        {/* Thumb */}
        <span className="absolute left-0.5 top-0.5 h-5 w-5 rounded-full bg-background border shadow transition-transform peer-checked:translate-x-5"></span>
      </label>
    );
  }
);
Switch.displayName = "Switch";

export { Switch };
